import { FC, ReactElement, ReactNode } from 'react'
import { MyLink, MyLinkProps } from 'components/MyLink'
import classNames from 'classnames'

export type ClickableCardLinkProps = MyLinkProps & {
  icon: ReactElement | ReactNode
}

export const ClickableCardLink: FC<ClickableCardLinkProps> = ({ children, icon, className, ...props }) => {
  return (
    <MyLink className={classNames('my-c-clickable-card', className)} {...props}>
      {icon && <span className='ds-u-margin-right--2'>{icon}</span>}
      <span>{children}</span>
    </MyLink>)
}
